<!--  -->
<template>
  <div class="policyform" v-title data-title="投保信息">
    <div class="header">
      <div>
        <img src="@/assets/img/header01.png" alt="" />
        <div class="logo">
          <img src="@/assets/img/logo2.png" alt="" />
        </div>
      </div>
    </div>
    <div class="list">
      <div class="container">
        <ul>
          <li :style="orderableStyle.company_title" class="company">
            投保人
            <input
              @blur="
                formColor(orderable.company_title, orderableStyle.company_title)
              "
              v-model="orderable.company_title"
              type="text"
              placeholder="填入信息"
            />
          </li>
          <li :style="orderableStyle.code" class="company">
            统一社会信用代码
            <input
              @blur="formColor(orderable.code, orderableStyle.code)"
              v-model="orderable.code"
              type="text"
              placeholder="填入信息"
            />
          </li>
          <li :style="orderableStyle.type">
            工程类型
            <el-radio-group
              @change="formColor(orderable.type, orderableStyle.type)"
              text-color="#323233"
              v-model="orderable.type"
            >
              <el-radio label="室内装修"></el-radio>
              <el-radio label="其他"></el-radio>
            </el-radio-group>
          </li>
          <!-- <li :style="orderableStyle.qualifications">
            施工资质
            <input
              @click="getpopupVisible('qualifications')"
              v-model="orderable.qualifications"
              type="text"
              readonly="readonly"
              placeholder="点击选择"
            />
          </li> -->
          <li :style="orderableStyle.address_area" class="address">
            工程地点
            <div class="wrap" @click="isShow = true">
              <div class="building">
                <input
                  @change="
                    formColor(
                      orderable.address_area,
                      orderableStyle.address_area
                    )
                  "
                  type="text"
                  placeholder="请选择省市区"
                  v-model="orderable.address_area"
                  disabled
                />
              </div>
            </div>
          </li>
          <li>
            <span class="title-none">详细地址</span>
            <div class="wrap wrap-1 wrap-other">
              <div>
                <input
                  class="input"
                  @blur="
                    formColor(
                      orderable.detail_address,
                      orderableStyle.detail_address
                    )
                  "
                  v-model="orderable.detail_address"
                  type="text"
                  placeholder="请输入详细地址"
                />
              </div>
            </div>
          </li>
          <li class="time-select">
            工程合同期限
            <div class="wrap">
              <div
                :style="orderableStyle.begin_time"
                @click="dateSelectfn('start')"
              >
                <mt-field
                  required
                  label="开始时间"
                  disabled
                  placeholder="请选择开始时间"
                  v-model="form.startTime"
                >
                </mt-field>
              </div>
              <div
                :style="orderableStyle.end_time"
                @click="dateSelectfn('end')"
              >
                <mt-field
                  required
                  label="结束时间"
                  disabled
                  placeholder="请选择结束时间"
                  v-model="form.endTime"
                >
                </mt-field>
              </div>
            </div>
          </li>
          <li
            :style="orderableStyle.insurance_policy_begin_time"
            class="insurer_time"
          >
            保单生效日
            <div class="wrap" @click="dateSelectfn('insurer_start')">
              <mt-field
                required
                label="保单生效日"
                disabled
                placeholder="请选择"
                v-model="form.insurer_begin"
              >
              </mt-field>
            </div>
          </li>
          <li :style="orderableStyle.owner">
            附加被保险人
            <div class="wrap wrap-1 wrap-other">
              <div>
                <input
                  placeholder="业主"
                  v-model="orderable.owner"
                  type="text"
                />
              </div>
            </div>
          </li>
          <li :style="orderableStyle.contractor">
            <span class="title-none">附加被保险人</span>
            <div class="wrap wrap-1 wrap-other">
              <div>
                <input
                  placeholder="承包商"
                  v-model="orderable.contractor"
                  type="text"
                />
              </div>
            </div>
          </li>
          <li :style="orderableStyle.subcontractor">
            <span class="title-none">附加被保险人</span>
            <div class="wrap wrap-1 wrap-other">
              <div>
                <input
                  placeholder="分包商"
                  v-model="orderable.subcontractor"
                  type="text"
                />
              </div>
            </div>
          </li>
          <li :style="orderableStyle.property">
            <span class="title-none">附加被保险人</span>
            <div class="wrap wrap-1 wrap-other">
              <div>
                <input
                  placeholder="物业公司"
                  v-model="orderable.property"
                  type="text"
                />
              </div>
            </div>
          </li>
          <li :style="orderableStyle.email">
            邮箱
            <input
              v-model="orderable.email"
              type="text"
              placeholder="填入信息"
            />
          </li>
          <li :style="orderableStyle.invoice_type">
            发票类型
            <!-- <input v-model="orderable.invoice_type" type="text" placeholder="点击选择" /> -->
            <div class="wrap-invoice_type">
              <el-radio-group
                @change="invoiceChange(orderable.invoice_type)"
                v-model="orderable.invoice_type"
              >
                <el-radio label="1">普票</el-radio>
                <el-radio label="2">专票</el-radio>
              </el-radio-group>
            </div>
          </li>
          <li :style="orderableStyle.invoice_info" v-show="isInvoice_type">
            联系人<input
              v-model="orderable.invoice_info.contact"
              type="number"
              placeholder="填入信息"
            />
          </li>
          <li :style="orderableStyle.invoice_info" v-show="isInvoice_type">
            联系人电话<input
              v-model="orderable.invoice_info.contact_phone"
              type="number"
              placeholder="填入信息"
            />
          </li>
          <li :style="orderableStyle.invoice_info" v-show="isInvoice_type">
            开户行<input
              v-model="orderable.invoice_info.bank"
              type="number"
              placeholder="填入信息"
            />
          </li>
          <li :style="orderableStyle.invoice_info" v-show="isInvoice_type">
            开户行账号<input
              v-model="orderable.invoice_info.bankAccount"
              type="number"
              placeholder="填入信息"
            />
          </li>
          <li :style="orderableStyle.invoice_info" v-show="isInvoice_type">
            注册地址<input
              v-model="orderable.invoice_info.Registered_address"
              type="number"
              placeholder="填入信息"
            />
          </li>
          <!-- <li>
            工程造价<input
              disabled
              v-model="orderable.engineering_cost"
              type="number"
              placeholder="填入信息"
            />
          </li>
          <li>
            第三者责任(每人赔偿限额)<input
              disabled
              v-model="base_data.single_limit"
              type="number"
              placeholder="填入信息"
            />
          </li>
          <li>
            第三者责任(每次事故及累计赔偿限额)<input
              v-model="base_data.total_limit"
              type="number"
              disabled
              placeholder="填入信息"
            />
          </li> -->
          <li>
            手机号码
            <input
              v-model="orderable.phone"
              type="text"
              placeholder="填入信息"
            />
          </li>
        </ul>
      </div>
    </div>
    <div class="footer">
      <div class="top">
        <el-checkbox v-model="isread_protocol"></el-checkbox>
        <span
          >我已阅读<a @click="getProtocolData(1)">《投保须知》</a
          ><a @click="getProtocolData(2)">《保险条款》</a
          ><a @click="getProtocolData(3)">《客户告知》</a
          ><a @click="getProtocolData(4)">《保险代理服务协议》</a></span
        >
      </div>

      <div class="footer-container">
        <div class="price">
          <div class="left">
            <div>测算</div>
            <div>保费金额</div>
          </div>
          <div class="right">
            <span class="price-value">{{ base_data.premium }}</span
            >元
          </div>
        </div>
        <div @click="upload" class="submit-btn-1">
          <div>拍照上传施工合同</div>
          <div>及营业执照</div>
        </div>
        <div @click="submitForm" class="submit-btn-2">确认提交</div>
      </div>
    </div>
    <div v-if="popupVisible" class="footer-open">
      <mt-popup
        v-model="popupVisible"
        popup-transition="popup-fade"
        position="bottom"
      >
        <div class="picker-toolbar-title">
          <div class="usi-btn-sure" @click="addrConfirm">确定</div>
        </div>
        <div class="picken-center"></div>
        <mt-picker
          ref="picker"
          :slots="slots"
          value-key="label"
          :itemHeight="50"
          @change="onValuesChange"
        >
        </mt-picker>
      </mt-popup>
    </div>
    <div v-show="popupVisible_upload" class="footer-open footer-open-upload">
      <mt-popup
        v-model="popupVisible_upload"
        popup-transition="popup-fade"
        position="bottom"
      >
        <div class="picker-toolbar-title">
          <div class="usi-btn-sure" @click="popupVisible_upload = false">
            确定
          </div>
        </div>
        <div class="btn-group">
          <el-upload
            class="avatar-uploader"
            accept="image/*"
            action="action"
            :auto-upload="false"
            :show-file-list="true"
            :on-change="beforeUpload1"
          >
            <div class="camera">
              <el-button type="primary" icon="el-icon-camera"
                >施工合同</el-button
              >
            </div>
          </el-upload>
          <el-upload
            class="avatar-uploader"
            accept="image/*"
            action="action"
            :auto-upload="false"
            :show-file-list="true"
            :on-change="beforeUpload2"
          >
            <div class="camera">
              <el-button type="primary" icon="el-icon-camera"
                >营业执照</el-button
              >
            </div>
          </el-upload>
        </div>
      </mt-popup>
    </div>
    <div
      v-if="popupVisible_start || popupVisible_end || popupVisible_insurerStart"
      class="footer-calendar"
    >
      <mt-popup position="bottom" v-model="popupVisible_start">
        <div class="btn">
          <el-button @click="popupVisible_start = false" type="primary" plain
            >确定</el-button
          >
        </div>
        <inlineCalendar
          :defaultDate="dateset.start.defaultDate"
          :minDate="dateset.start.minDate"
          :maxDate="dateset.start.maxDate"
          mode="single"
          @change="datechange"
        />
      </mt-popup>
      <mt-popup position="bottom" v-model="popupVisible_end">
        <div class="btn">
          <el-button @click="popupVisible_end = false" type="primary" plain
            >确定</el-button
          >
        </div>
        <inlineCalendar
          ref="dateset_end"
          :defaultDate="dateset.end.defaultDate"
          :minDate="dateset.end.minDate"
          :maxDate="dateset.end.maxDate"
          mode="single"
          @change="datechange"
        />
      </mt-popup>
      <mt-popup position="bottom" v-model="popupVisible_insurerStart">
        <div class="btn">
          <el-button
            @click="popupVisible_insurerStart = false"
            type="primary"
            plain
            >确定</el-button
          >
        </div>
        <inlineCalendar
          :defaultDate="dateset.insurer_start.defaultDate"
          :minDate="dateset.insurer_start.minDate"
          :maxDate="dateset.insurer_start.maxDate"
          mode="single"
          @change="datechange"
        />
      </mt-popup>
    </div>
    <mt-popup
      v-model="read_protocol"
      popup-transition="popup-fade"
      position="center"
      class="protocol"
    >
      <div class="container">{{ protocolData }}</div>
      <div class="ensure">
        <el-button @click="read_protocol = false" type="primary"
          >确定</el-button
        >
      </div>
    </mt-popup>
    <div class="mocPicker" v-show="isShow">
      <div class="mask">
        <div class="linkage">
          <h2>
            请选择所在地区
            <el-button @click="changeArea" type="primary">确定</el-button>
          </h2>
          <div class="linkPageMine clearfix">
            <div class="province pickerWrapper">
              <mt-picker
                :slots="provinces"
                @change="onProvinceChange"
                value-key="city_name"
              ></mt-picker>
            </div>
            <div class="city pickerWrapper">
              <mt-picker
                :slots="citys"
                @change="onCityChange"
                value-key="city_name"
              ></mt-picker>
            </div>
            <div class="area pickerWrapper">
              <mt-picker
                :slots="areas"
                @change="onAreaChange"
                value-key="city_name"
              ></mt-picker>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div v-if="read_protocol" class="protocol">
      <div class="container"></div>
    </div> -->
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { subOrderApi, getInsurerListApi } from "@/api";
import myaddress from "@/utils/area.json";
import { MessageBox } from "mint-ui";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    provinceVal: String,
    cityVal: String,
    districtVal: String,
  },
  data() {
    //这里存放数据
    return {
      isShow: false,
      address_area: "",
      CITY_DATA: [],
      province: {
        city_name: "北京",
        city_code: "110000",
      },
      maskFlag: false,
      city: {
        city_name: "市辖区",
        city_code: "110100",
      },
      area: {
        city_name: "东城区",
        city_code: "110101",
      },
      flag: 0, //最开始省市区那三个picker会初始化调用change事件，但是此时没有省市区数据，因此会报错，
      //所以以这个标识符来控制当时第一次初始化时调用change事件时直接return
      provinces: [
        {
          flex: 1,
          values: [],
          className: "slot1",
          textAlign: "center",
        },
        {
          divider: true,
          content: "-",
          className: "right",
        },
      ],
      citys: [
        {
          flex: 1,
          values: [],
          className: "slot1",
          textAlign: "center",
        },
        {
          divider: true,
          content: "-",
          className: "slot2",
        },
      ],
      areas: [
        {
          flex: 1,
          values: [],
          className: "slot1",
          textAlign: "center",
        },
      ], //
      popupVisible_start: false,
      popupVisible_end: false,
      popupVisible_insurerStart: false,
      popupVisible_upload: false,
      isread_protocol: false,
      read_protocol: false,
      protocolData: "",
      form: {
        startTime: this.$moment().add(2, "days").format("YYYY-MM-DD"),
        endTime: this.$moment().add(30, "days").format("YYYY-MM-DD"),
        insurer_begin: this.$moment().add(2, "days").format("YYYY-MM-DD"),
      },
      dateset: {
        type: "",
        start: {
          defaultDate: "",
          minDate: "",
          maxDate: "",
        },
        insurer_start: {
          defaultDate: new Date(Date.now() + 24 * 3600 * 1000 * 2),
          minDate: new Date(Date.now() + 24 * 3600 * 1000 * 2),
          maxDate: "",
        },
        end: {
          defaultDate: "",
          minDate: "",
          maxDate: "",
        },
      },
      popupVisible: false,
      radio: "",
      insurerPrice: "",
      buildlist: [],
      isInvoice_type: false,
      qualificationslist: [
        {
          value: " 特级",
          label: "特级",
        },
        {
          value: "一级",
          label: "一级",
        },
        {
          value: "二级",
          label: "二级",
        },
      ],
      typelist: [
        {
          value: "室内装修",
          label: "室内装修",
        },
        {
          value: "展会搭建/拆除",
          label: "展会搭建/拆除",
        },
      ],
      base_data: {
        start_time: "",
        duration: "",
        premium: "",
        insured_amount: "",
        total_limit: "",
        single_limit: "",
      },
      orderableStyle: {
        address_area: { color: "#000" },
        insurance_policy_begin_time: { color: "#000" },
        company_title: { color: "#000" },
        code: { color: "#000" },
        site_id: { color: "#000" },
        detail_address: { color: "#000" },
        type: { color: "#000" },
        phone: { color: "#000" },
        begin_time: { color: "#000" },
        end_time: { color: "#000" },
        owner: { color: "#000" },
        contractor: { color: "#000" },
        subcontractor: { color: "#000" },
        email: { color: "#000" },
        invoice_type: { color: "#000" },
        engineering_cost: { color: "#000" },
        userinfo: {},
        contact: { color: "#000" },
        bank: { color: "#000" },
        bankAccount: { color: "#000" },
        contact_phone: { color: "#000" },
        Registered_address: { color: "#000" },
      },
      orderable: {
        insurance_policy_begin_time: "",
        company_title: "",
        code: "",
        site_id: "",
        detail_address: "",
        address_area: "",
        type: "",
        phone: "",
        begin_time: "",
        end_time: "",
        owner: "",
        contractor: "",
        photos: {
          Construction_contracts: "",
          License: "",
        },
        subcontractor: "",
        email: "",
        invoice_type: "普票",
        engineering_cost: "",
        invoice_info: {
          contact: "",
          bank: "",
          bankAccount: "",
          contact_phone: "",
          Registered_address: "",
        },
      },
      inputType: "",
      slots: [
        {
          values: [],
        },
      ],
      insurerInfo: {},
      pickerOptions0: {
        disabledDate: (time) => {
          if (this.orderable.end_time != "") {
            let max = 6 * 30 * 24 * 3600 * 1000;
            let sixMonth = this.orderable.end_time.getTime() - max;
            return (
              time.getTime() > this.orderable.end_time ||
              time.getTime() < sixMonth
            );
          }
        },
      },
      pickerOptions1: {
        disabledDate: (time) => {
          if (this.orderable.begin_time != "") {
            let max = 6 * 30 * 24 * 3600 * 1000;
            let sixMonth = this.orderable.begin_time.getTime() + max;
            return (
              time.getTime() < this.orderable.begin_time.getTime() ||
              time.getTime() > sixMonth
            );
          }
        },
      },
      pickerOptions3: {
        disabledDate(time) {
          let twoDay = 2 * 24 * 3600 * 1000;
          return time.getTime() <= Date.now() - 8.64e7 + twoDay;
        },
      },
    };
  },
  //监听属性 类似于data概念
  computed: {
    result() {
      return {
        province: this.province.city_name,
        city: this.city.city_name,
        district: this.area.city_name,
        provinceId: this.province.city_code,
        cityId: this.city.city_code,
        districtId: this.area.city_code,
      };
    },
  },
  //监控data中的数据变化
  watch: {
    //
  },
  //方法集合
  methods: {
    getProtocolData(e) {
      this.read_protocol = true;
      if (e == "1") {
        this.protocolData = this.insurerInfo.insurances[0].notice_insurance;
      } else if (e == "2") {
        this.protocolData = this.insurerInfo.insurances[0].clause;
      } else if (e == "3") {
        this.protocolData = this.insurerInfo.insurances[0].client_notice;
      } else if (e == "4") {
        this.protocolData = this.insurerInfo.insurances[0].service;
      }
    },
    getInsurerList() {
      getInsurerListApi().then((res) => {
        this.insurerInfo = res.data.data;
        this.orderable.site_id = this.insurerInfo.id;
      });
    },
    beforeUpload1(file) {
      this.orderable.photos.Construction_contracts = file;
    },
    beforeUpload2(file) {
      this.orderable.photos.License = file;
    },
    datechange(date) {
      // console.log(date);
      if (this.dateset.type == "start") {
        this.form.startTime = date.format("YYYY-MM-DD");
        this.orderable.begin_time = date.format("YYYY-MM-DD");
        this.dateset.end.maxDate = date.add(6, "months").format("YYYY-MM-DD");
        this.dateset.end.minDate = date.format("YYYY-MM-DD");
        this.formColor(
          this.orderable.begin_time,
          this.orderableStyle.begin_time
        );
      } else if (this.dateset.type == "end") {
        this.form.endTime = date.format("YYYY-MM-DD");
        this.orderable.end_time = date.format("YYYY-MM-DD");
        this.dateset.start.minDate = date
          .add(-6, "months")
          .format("YYYY-MM-DD");
        this.dateset.start.maxDate = date.format("YYYY-MM-DD");
        this.formColor(this.orderable.end_time, this.orderableStyle.end_time);
      } else if (this.dateset.type == "insurer_start") {
        this.orderable.insurance_policy_begin_time = date.format("YYYY-MM-DD");
        this.form.insurer_begin = date.format("YYYY-MM-DD");
        this.formColor(
          this.orderable.insurance_policy_begin_time,
          this.orderableStyle.insurance_policy_begin_time
        );
      }
    },
    dateSelectfn(type) {
      if (type == "start") {
        this.dateset.type = "start";
        this.popupVisible_start = true;
      } else if (type == "end") {
        this.dateset.type = "end";
        this.popupVisible_end = true;
      } else if (type == "insurer_start") {
        this.dateset.type = "insurer_start";
        this.popupVisible_insurerStart = true;
      }
    },
    getpopupVisible(e) {
      this.inputType = e;
      if (e == "type") {
        this.slots[0].values = this.typelist;
      } else if (e == "qualifications") {
        this.slots[0].values = this.qualificationslist;
      }
      this.popupVisible = true;
    },
    onValuesChange(picker, values) {
      // console.log(values);
      if (this.inputType == "type") {
        this.orderable.type = values[0].label;
      } else if (this.inputType == "qualifications") {
        this.orderable.qualifications = values[0].label;
      }
    },
    addrConfirm() {
      this.popupVisible = false;
    },
    formColor(item1, item2) {
      console.log(item1, item2);
      if (item1 == "") {
        item2.color = "#f55";
        // console.log(this.orderableStyle);
        this.$forceUpdate();
      } else if (item1 == "select") {
        item2.color = "#000";
      } else {
        item2.color = "#000";
      }
      // console.log(item2);
    },
    footercClose() {
      if (
        this.orderable.contact != "" &&
        this.orderable.bank != "" &&
        this.orderable.bankAccount != ""
      ) {
        this.popupVisible = false;
      }
    },
    invoiceChange(e) {
      // console.log(e);
      if (e == 2) {
        this.isInvoice_type = true;
      } else {
        this.isInvoice_type = false;
      }
    },
    upload() {
      this.popupVisible_upload = true;
    },
    submitForm() {
      // this.orderable.room =
      //   this.orderable.roomData.ridgepole +
      //   "栋" +
      //   this.orderable.roomData.layer +
      //   "层" +
      //   this.orderable.roomData.room +
      //   "室";
      // console.log(this.orderable);

      this.orderable.detail_address =
        this.address_area + this.orderable.detail_address;
      console.log(this.orderable.detail_address);
      var obj = {
        base_data: this.base_data,
        orderable: this.orderable,
        type_id: "1",
      };
      // console.log(obj);
      var flag = true;
      this.orderableStyle = {
        insurance_policy_begin_time: { color: "#000" },
        company_title: { color: "#000" },
        code: { color: "#000" },
        detail_address: { color: "#000" },
        address_area: { color: "#000" },
        site_id: { color: "#000" },
        type: { color: "#000" },
        phone: { color: "#000" },
        begin_time: { color: "#000" },
        end_time: { color: "#000" },
        owner: { color: "#000" },
        contractor: { color: "#000" },
        subcontractor: { color: "#000" },
        email: { color: "#000" },
        invoice_type: { color: "#000" },
        engineering_cost: { color: "#000" },
        invoice_info: { color: "#000" },
        photos: { color: "#000" },
      };
      for (const i in this.orderable) {
        // console.log(i, ":", this.orderable[i], this.orderableStyle[i]);
        let dataType = Object.prototype.toString.call(this.orderable[i]);
        if (dataType == "[object String]") {
          if (this.orderable[i].length == 0) {
            MessageBox("提交订单失败", "请填写完整信息");
            flag = false;
            this.orderableStyle[i].color = "#f55";
            if (i == "detail_address") {
              this.orderableStyle["address_area"].color = "#f55";
            }
            // console.log(i);
          }
        } else if (dataType == "[object Object]") {
          if (i == "invoice_type" && this.orderable[i] == 1) {
            MessageBox("提交订单失败", "");
          } else if (i == "photos") {
            for (let pi in this.orderable[i]) {
              if (!this.orderable[i][pi].name) {
                flag = false;
                MessageBox("提交订单失败", "请上传施工合同及营业执照");
              }
            }
          } else if (i != "invoice_info") {
            for (const j in this.orderable[i]) {
              if (this.orderable[i][j].length == 0) {
                flag = false;
                this.orderableStyle[i].color = "#f55";
                // console.log(this.orderable[i], j);
              }
            }
          }
        }
      }
      // console.log(this.orderableStyle);

      if (!this.isread_protocol) {
        flag = this.isread_protocol;
        MessageBox("提交订单失败", "请阅读协议并勾选");
      }
      console.log(flag);
      if (flag) {
        console.log(obj);
        subOrderApi(obj).then((res) => {
          console.log(res.data);
          if (res.data.status == 1) {
            this.$router.push({
              name: "Success",
            });
          }
        });
      }
    },
    _hideLinkage() {
      // console.log('sdgdfgdfgdfg');
      // this.$emit("getLinkage", this.result, false); //触发父组件的getLinkage事件接收结果数据
    },
    changeArea() {
      this.isShow = false;
      console.log(
        this.province.city_name,
        this.city.city_name,
        this.area.city_name
      );
      this.orderable.address_area =
        this.province.city_name +
        "-" +
        this.city.city_name +
        "-" +
        this.area.city_name;
    },
    onProvinceChange(picker, values) {
      if (this.flag === 0) {
        return;
      }
      let provinceIndex = picker.getSlotValue(0);
      this.province = provinceIndex;
      let city = this._getCity(this.province.city_code);
      this.citys[0].values = city;
      this.city = city[0];
    },
    onCityChange(picker, values) {
      if (this.flag === 0) {
        return;
      }
      let cityIndex = picker.getSlotValue(0);
      this.city = cityIndex;
      let provinceIndex = this.province;
      let area = this._getArea(this.province.city_code, this.city.city_code);
      this.areas[0].values = area;
      this.area = area[0];
    },
    onAreaChange(picker, values) {
      if (this.flag === 0) {
        this.flag = 1;
        return;
      }
      let areaIndex = picker.getSlotValue(0);
      this.area = areaIndex;
    },
    //得到省份数据
    _getProvince() {
      let province = [];
      this.CITY_DATA.provinces.province.forEach(function (item, index) {
        let obj = {};
        obj.city_code = item.city_code;
        obj.city_name = item.city_name;
        province.push(obj);
      });
      console.log(province);
      return province;
    },
    //根据省份得到城市数据
    _getCity(provinceId) {
      let city = [];
      this.CITY_DATA.provinces.province.forEach((item, index) => {
        if (item.city_code === provinceId) {
          item.cities.city.forEach((item, index) => {
            let obj = {};
            obj.city_code = item.city_code;
            obj.city_name = item.city_name;
            city.push(obj);
          });
        }
      });
      return city;
    },
    //根据城市和省份得到区域数据
    _getArea(provinceId, cityId) {
      let area = [];
      this.CITY_DATA.provinces.province.forEach((item, index) => {
        if (item.city_code === provinceId) {
          item.cities.city.forEach((item, index) => {
            if (item.city_code === cityId) {
              item.areas.area.forEach((item) => {
                let obj = {};
                obj.city_code = item.city_code;
                obj.city_name = item.city_name;
                area.push(obj);
              });
            }
          });
        }
      });
      if (area.length == 0) {
        //如果没有区域数据则第三个picker显示的内容
        area.push({
          city_name: "没有",
          city_code: "000000",
        });
      }
      return area;
    },
  },
  beforeCreate() {}, //生命周期 - 创建之前
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.CITY_DATA = myaddress;
    this.provinces[0].values = this._getProvince();
    this.citys[0].values = this._getCity("110000");
    this.areas[0].values = this._getArea("110000", "110100");
  },
  beforeMount() {}, //生命周期 - 挂载之前
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getInsurerList();
    this.base_data.total_limit = this.$store.state.insurerprice.total_limit;
    this.base_data.insured_amount = this.$store.state.insurerprice.total_limit;
    this.base_data.single_limit = this.$store.state.insurerprice.single_limit;
    this.base_data.premium = this.$store.state.insurerprice.premium;
    this.orderable.engineering_cost =
      this.$store.state.insurerprice.engineering_cost;
    this.orderable.phone = this.$store.state.phone;
    this.orderable.invoice_info.contact_phone = this.$store.state.phone;
  },
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less">
.policyform {
  width: 100%;
  height: 100%;
  background: #f1f1f1;
  position: relative;
  overflow-x: hidden;
  // overflow: scroll;
  .mint-cell:last-child {
    background: #fff;
  }
  .mint-field .mint-cell-title {
    width: 100%;
    text-align: right;
    margin-left: -1rem;
  }
  .mint-cell-wrapper {
    background: #fff;
    flex-wrap: wrap !important;
    padding: 0 !important;
    font-size: 14px;
    justify-content: center;
  }
  .mint-cell-value {
    font-size: 14px;
  }
  .header {
    position: relative;
    display: flex;
    color: #fff;
    > div {
      width: 100%;
      height: 10rem;
      .logo {
        position: absolute;
        top: calc(50% - 5rem);
        left: calc(50% - 14.3rem);
        height: 8rem;
        width: 28.6rem;

        font-size: 2rem;
      }
      .title {
        margin-left: 2rem;
        padding: 1rem;
        font-size: 2.8rem;
        letter-spacing: 0.5rem;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .list {
    background: #fff;
    padding: 0rem 3rem;
    padding-bottom: 2rem;
    ul {
      width: 100%;
      li {
        display: flex;
        justify-content: space-between;
        width: 100%;
        border-bottom: 1px solid #c8c8c8;
        padding: 1rem 0;
        font-size: 14px;
        .title-none {
          color: #fff;
        }
        .el-radio-group {
          .el-radio {
            margin-right: 5px !important;
            .el-radio__label {
              font-weight: bold;
            }
          }
          .el-radio.is-checked {
            .el-radio__label {
              color: #30262a;
            }
            .el-radio__inner {
              width: 16px;
              height: 16px;
              border-color: #dcdfe6;
              background: #dcdfe6;
            }
            .el-radio__inner::after {
              width: 8px;
              height: 8px;
              background: #6d6d6d;
            }
          }
        }
        .wrap {
          display: flex;
          justify-content: flex-end;
          font-size: 14px;
          .small-font {
            width: 8rem;
          }
          > div {
            display: flex;
            max-width: 15rem;
            input {
              max-width: 4rem;
            }
          }
        }
        .wrap-invoice_type {
          input {
            width: 3rem;
          }
        }
        .wrap-1 {
          > div {
            max-width: 12rem;
            width: 12rem;
            input {
              max-width: 6rem;
            }
          }
        }
        .wrap-other {
          > div {
            max-width: 22rem;
            width: 22rem;
            input {
              width: 22rem;
              max-width: 22rem !important;
            }
          }
        }
        input {
          width: 8rem;
          text-align: right;
          margin-right: 5px;
          background: #fff;
        }
        .el-select {
          width: 10rem;
          input {
            width: 10rem;
            text-align: right;
            margin-right: 0px;
          }
        }
      }
      .insurer_time {
        align-items: center;
        input {
          width: 7rem;
        }
      }
      .company {
        input {
          width: 18rem;
        }
      }
      .address {
        align-items: center;
        justify-content: space-between;
        .wrap {
          width: 25rem;
          align-items: center;
          flex-wrap: wrap;
          .building {
            width: 25rem;
            max-width: 50rem;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            input {
              max-width: 50rem;
              width: 100%;
            }
          }
          .wrap-1 {
            max-width: 22rem;
            > div {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              input {
                max-width: 4rem;
              }
            }
            .input {
              max-width: 13rem;
              width: 14rem;
            }
          }
        }
        .el-select {
          width: 6rem;
          .el-input--suffix {
            width: 4rem;
            margin-right: 0;
            .el-input__inner {
              width: 10rem;
              max-width: 10rem;
              padding: 0;
              text-align: center;
            }
            .el-input__suffix {
              display: none;
              right: -0.5rem;
            }
          }
        }
      }
      .time-select {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .wrap {
          display: flex;
          margin-left: 2rem;
          > div {
            width: 8rem;
          }

          .mint-cell {
            width: 8rem;
            .mint-cell-wrapper {
              .mint-cell-value {
                input {
                  text-align: left;
                }
              }
            }
          }
          > div {
            display: block;
            margin-bottom: 1rem;
            input {
              width: 8rem;
              text-align: right !important;
              max-width: 14rem;
            }
          }
        }
      }
    }
  }
  .footer {
    padding: 0.5rem 3rem;
    padding-bottom: 3rem;
    .el-radio__label {
      font-size: 12px;
    }
    .top {
      .el-checkbox {
        // transform: scale(0.7);
        // margin-left: -5rem;
        white-space: pre-wrap;
        .el-checkbox__inner {
          z-index: 0;
        }
      }
    }
    .footer-container {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      .price {
        display: flex;
        justify-content: flex-start;
        .left {
          display: flex;
          flex-wrap: wrap;
          align-content: flex-end;
          width: 5rem;
        }
        .right {
          display: flex;
          align-items: flex-end;
          .price-value {
            line-height: 2rem;
            font-size: 2.5rem;
            color: #1556bc;
          }
        }
      }
      .submit-btn-1 {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-content: center;
        font-size: 12px;
        max-width: 12rem;
        width: 12rem;
        height: 5rem;
        background: #d5a169;
        padding-left: 1rem;
        padding-right: 1rem;
        color: #fff;
        box-sizing: border-box;
        border-radius: 1.5rem;
        margin-left: 0.5rem;
      }
      .submit-btn-2 {
        line-height: 2.5rem;
        max-width: 11rem;
        width: 11rem;
        height: 5rem;
        font-size: 12px;
        background: #1556bc;
        padding: 1rem 1rem 1rem 1rem;
        color: #fff;
        box-sizing: border-box;
        border-radius: 1.5rem;
        margin-left: 0.5rem;
      }
    }
  }
  // .footer-open {
  //   position: absolute;
  //   bottom: 0;
  //   // border: 1px solid red;
  //   box-sizing: border-box;
  //   background: #f2f2f2;
  //   width: 100%;
  //   // height: 30rem;
  //   padding: 3rem;
  //   .btn {
  //     display: flex;
  //     justify-content: flex-end;
  //   }
  // }
  .protocol {
    // background: RGBA(40,40,40,0.5);
    min-height: 46%;
    width: 90% !important;
    padding: 2rem;
    box-sizing: border-box;
    .container {
      text-indent: 2em;
      // width: 80%;
      // background: #fff;
    }
    .ensure {
      display: flex;
      width: 100%;
      justify-content: flex-end;
      .el-button {
        margin: 2rem 0;
      }
    }
  }
  .picker-slot {
    font-size: 30px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 11;
  }
  .linkage {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 40%;
    padding-top: 1rem;
    background: #fff;
    left: 0;
    border-radius: 10px 10px 0 0;
    h2 {
      display: flex;
      justify-content: space-around;
      align-items: center;
      font-size: 20px;
      font-weight: bold;
      padding: 10px 20px;
      text-indent: 1em;
    }
    .linkPageMine {
      margin: 50px auto;
      margin-top: 0;
      padding: 30px 0;
      .pickerWrapper {
        width: 33.3%;
        float: left;
      }
    }
  }
  .picker-center-highlight {
    top: 46%;
  }
  .footer-calendar {
    width: 100%;
    position: fixed;
    bottom: 0;
    height: 36rem;
    .btn {
      height: 6rem;
      padding: 1rem;
      box-sizing: border-box;
      display: flex;
      justify-content: flex-end;
    }
  }
  .dateSelect {
    position: fixed;
    height: 40rem;
    bottom: 0;
    .picker-toolbar {
      display: flex;
      justify-content: center;
      padding: 2rem 0;
      span {
        padding: 0 2rem;
        font-size: 20px;
        color: #108ee9;
      }
    }
    .picker-items {
      height: 40rem;
      display: flex;
    }
  }
  .footer-open {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 30rem;
    background: #fff;
    .mint-popup {
      width: 100%;
      height: 100%;
      background: #fff;
    }
  }
  .footer-open-upload {
    position: fixed;
    bottom: 0;
    z-index: 10;
    padding-bottom: 10rem;
    .mint-popup {
      width: 100%;
      height: 40%;
      background: #fff;
    }
    .btn-group {
      display: flex;
      height: 100%;
      padding: 2rem;
      padding-top: 4rem;
      flex-wrap: wrap;
      justify-content: space-around;
      align-content: flex-start;
      > div {
        width: 100%;
        height: 30%;
      }
      i {
        font-size: 16px;
      }
    }
  }
  .mint-popup {
    width: 100%;
    background: #fff;
  }
  .picker-item {
    text-align: center;

    font-size: 1.6rem;
  }
  .picker-slot {
    height: 20rem !important;
    overflow: hidden;
  }
  .picken-center {
    position: absolute;
    top: 45%;
    width: 100%;
    height: 52px;
    border-top: 2px solid #cecece;
    border-bottom: 2px solid #cecece;
    // background: blue;
    opacity: 0.6;
  }
  .picker-selected {
    font-size: 2rem;
    font-weight: bolder;
  }
  .picker-toolbar-title {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    background: #f5f5f5;
    padding-right: 3rem;
  }
  .usi-btn-cancel,
  .usi-btn-sure {
    color: #108ee9;
  }
}
</style>
